var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCode = function SvgIconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1h2a3 3 0 0 1 3 3v2M6 1H4a3 3 0 0 0-3 3v2m13 13h2a3 3 0 0 0 3-3v-2M6 19H4a3 3 0 0 1-3-3v-2",
    stroke: "#1D1D1D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5v10m-3-10v10m-3-10v10m-3-10v10",
    stroke: "#1D1D1D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
export { SvgIconCode as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDFIMTZDMTcuNjU2OSAxIDE5IDIuMzQzMTUgMTkgNFY2TTYgMUg0QzIuMzQzMTUgMSAxIDIuMzQzMTUgMSA0VjZNMTQgMTlIMTZDMTcuNjU2OSAxOSAxOSAxNy42NTY5IDE5IDE2VjE0TTYgMTlINEMyLjM0MzE1IDE5IDEgMTcuNjU2OSAxIDE2VjE0IiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjUgNUwxNC41IDE1TTExLjUgNUwxMS41IDE1TTguNSA1TDguNSAxNU01LjUgNUw1LjUgMTUiIHN0cm9rZT0iIzFEMUQxRCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";